import { SearchOutlined } from '@ant-design/icons'
import { Input } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { PAGE_PARAM, SEARCH_PARAM } from '../../../constants/query-params'
import useQueryParam from '../../../hooks/useQueryParam'
import useQueryParamSetter from '../../../hooks/useQueryParamSetter'
import useDebounce from '../../../hooks/useDebounce'

const SearchInput = ({ debounceTime = 700, searchParam = SEARCH_PARAM, ...props }) => {
    const search = useQueryParam(searchParam)
    const setQueryParam = useQueryParamSetter()
    const inputRef = useRef()

    const searchChagneTimeoutRef = useRef(null)

    const [searchValue, setSearchValue] = useState(search || '')

    const debounceSearchChange = useDebounce(
        searchValue => {
            setQueryParam({ [searchParam]: searchValue, [PAGE_PARAM]: undefined })
        },
        debounceTime,
        [setQueryParam, searchParam],
    )

    const handleSearchChange = event => {
        setSearchValue(event.target.value)
        debounceSearchChange(event.target.value)

        if (searchChagneTimeoutRef.current) {
            clearTimeout(searchChagneTimeoutRef.current)
        }

        searchChagneTimeoutRef.current = setTimeout(() => {
            searchChagneTimeoutRef.current = null
        }, 10000)
    }

    // Update local state when URL parameter changes
    useEffect(() => {
        if (searchChagneTimeoutRef.current) {
            return
        }

        setSearchValue(search || '')
    }, [search])

    return (
        <Input
            ref={inputRef}
            prefix={<SearchOutlined />}
            style={{ width: 320 }}
            allowClear
            value={searchValue}
            onChange={handleSearchChange}
            {...props}
        />
    )
}

export default SearchInput
